import type { UserWorkspace } from '@/api/types'

/**
 * What the bell shows for the workspace on screen.
 *
 * The user-level count is added in because the list endpoint returns both: it
 * filters `workspace_id = <id> OR workspace_id IS NULL`, so opening the panel
 * here is what reads a notification addressed to the user rather than to any
 * workspace. A badge that left those out would sit at zero over a panel with
 * unread items in it.
 */
export function unreadHere(
  workspace: UserWorkspace | undefined,
  userUnreadCount: number,
): number {
  return (workspace?.unread_notifications_count ?? 0) + userUnreadCount
}
